import * as reactQuery from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { useCountertopUniversity } from "../contexts/countertopUniversityContext";
import { CountertopUniversityCertificationResult } from "../types/CountertopUniversityCertificationResult";

export const useGenerateCountertopUniversityCertificate = (
	fullname: string,
	email: string,
	onSuccess: (data: CountertopUniversityCertificationResult) => void,
	onError: (error: string) => void) => {

	const context = useCountertopUniversity();

	const { mutate, data, isLoading } = reactQuery.useMutation({
		mutationFn: async () => {
			return await apiClient.post("countertop-university/save-certificate", {
				profileID: context.profileID,
				fullName: fullname,
				emailTo: email,
				countertopUniversityID: context.countertopUniversityId
			}) as CountertopUniversityCertificationResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when generating the certificate: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate,
		data,
		isLoading: isLoading
	};
};
